
import { Vue, Component, Prop } from 'vue-property-decorator';
import OutputFieldBase from '@/ui/components/devices/devices/base/OutputFieldBase.vue';
import BatteryBase from '@/ui/components/devices/devices/base/BatteryBase.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';
import LabelUnitWrapper from '@/ui/components/devices/components/LabelUnitWrapper.vue';
import { IDevice } from '@/types/devices.types';

/**
 * Component that represent Battery device
 */
@Component({
  components: {
    OutputFieldBase,
    BatteryBase,
    DeviceLayout,
    LabelUnitWrapper,
  },
})
export default class Battery extends Vue {
  @Prop() deviceData!: IDevice;
}
